import { fromJS } from 'immutable'
import { LOCATION_CHANGE } from 'react-router-redux'

const initialRouterState = fromJS({
  locationBeforeTransitions: null,
})

export default function routeReducer(state = initialRouterState, action) {
  switch (action.type) {
    case LOCATION_CHANGE:
      return state.merge({ locationBeforeTransitions: action.payload })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/router/reducer.js